// extracted by mini-css-extract-plugin
export default {"zones":"index_zones__oMdFj","formWrap":"index_formWrap__va6Fm","del":"index_del__1j4br"};